module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_0.c0a731af.png";